import { useCallback, useRef } from 'preact/hooks';

import { useFocusWithin } from '../hooks/UNSAFE_useFocusWithin';

export function usePopupFocusWithin() {
  const ref = useRef<HTMLElement | null>(null);
  const { focusProps, isFocused } = useFocusWithin();

  const onTransitionEnd = useCallback(
    (isAfterOpen?: boolean) => {
      if (isAfterOpen) {
        if (focusProps.onFocusIn) {
          ref.current?.addEventListener('focusin', focusProps.onFocusIn, false);
        }
        if (focusProps.onFocusOut) {
          ref.current?.addEventListener('focusout', focusProps.onFocusOut, false);
        }
      } else {
        if (focusProps.onFocusIn) {
          ref.current?.removeEventListener('focusin', focusProps.onFocusIn, false);
        }
        if (focusProps.onFocusOut) {
          ref.current?.removeEventListener('focusout', focusProps.onFocusOut, false);
        }
      }
    },
    [focusProps.onFocusIn, focusProps.onFocusOut, ref]
  );

  return {
    isFocused,
    popupProps: {
      onTransitionEnd,
      ref
    }
  };
}
